module.exports = __webpack_public_path__ + "img/logo.84de37b5.png";